import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input } from 'semantic-ui-react'

import moment from 'moment'

import constants from '../../constants'

class SubjectsAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      code: '',
      description: '',
      subjectCategory: '',
      showModal: false,
    };
  }

  handleChange = (e, { name, value }) => {
    if(name === 'name') {
      let code = value.replace(/\s/g, '')
      code = code + '-' + moment().format('MMDDYYYY')
      this.setState({ [name]: value, code:  code.toUpperCase() })
    } else {
      this.setState({ [name]: value })
    }
  }

  handleSubmit = () => {
    let code = this.state.code;
    if(this.state.code.length > 25) {
      code = this.state.code.substr(this.state.code.length-25, this.state.code.length);
    }
    const data = {
      name: this.state.name,
      code,
      description: this.state.description,
      subjectCategory: this.state.subjectCategory,
      // Selected school year, not the isCurrent one — see SectionsAdd.
      schoolYearId: this.props.schoolYearId
    };
    this.props.handleSubmit(data);
    this.setState({
      name: '',
      code: '',
      description: '',
      subjectCategory: ''
    })
    this.closeModal();
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  render() {
    const optionsSubjectCategory= constants.subjectCategory;
    return (
      <Modal
        trigger={
          <Button icon floated='right' labelPosition='right' color='green' onClick={this.openModal}> <Icon name='add' />
          Add Subject
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>Add Subject</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.name} name='name' label='Name' placeholder='Name' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.code} name='code' label='Code' placeholder='Code' disabled  className='subject-disabled'/>
            </Form.Group>

            <Form.Group widths='equal'>
              <Form.Select
                fluid
                search
                clearable
                name='subjectCategory'
                label='Subject Category'
                placeholder='Subject Category'
                options={optionsSubjectCategory}
                onChange={this.handleChange}
                value={this.state.subjectCategory}
              />
              <Form.Field control={Input} value={this.state.description} name='description' label='Description' placeholder='Description' onChange={this.handleChange}/>
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.handleSubmit()}>Submit</Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default SubjectsAdd;
